import { configureStore} from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { loginReducer } from './loginSlice'
import { deptReducer } from './deptSlice';
import ReactWebSiteApi from './ReactWebSiteApi'
import reactapiApi from './reactapiApi'
const store = configureStore({
    reducer: {
        //网站       
        login: loginReducer,    
        dept: deptReducer,     
        [ReactWebSiteApi.reducerPath]: ReactWebSiteApi.reducer,    
        [reactapiApi.reducerPath]: reactapiApi.reducer,   
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware().concat(
            ReactWebSiteApi.middleware,
            reactapiApi.middleware,
        ),
    
    }
);

setupListeners(store.dispatch)

export default store;